"use strict";

import { Swiper, Pagination } from "swiper";

const selector = ".js-promotional-banner-split-carousel";
const instances = new Map();
const mobileMediaQuery = window.matchMedia("(max-width: 768px)");

const shouldEnableMobileSlider = () => mobileMediaQuery.matches;

const createSwiper = ($carousel) => new Swiper($carousel.get(0), {
    modules: [Pagination],
    slidesPerView: 1,
    spaceBetween: 0,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    pagination: {
        el: $carousel.find(".js-swiper-pagination").get(0),
        clickable: true,
        type: "bullets",
    },
});

const syncCarousel = ($carousel) => {
    const carouselId = $carousel.data("id");
    const existingInstance = instances.get(carouselId);
    const pagination = $carousel.find(".js-swiper-pagination").get(0);

    if (shouldEnableMobileSlider()) {
        if (!existingInstance) {
            instances.set(carouselId, createSwiper($carousel));
        } else {
            existingInstance.update();
        }

        return;
    }

    if (existingInstance) {
        existingInstance.destroy(true, true);
        instances.delete(carouselId);

        if (pagination) {
            pagination.innerHTML = "";
        }
    }
};

const initPromotionalBannerSplitLayout = () => {
    const $carousels = $(selector);

    if (!$carousels.length) {
        return;
    }

    $carousels.each(function () {
        syncCarousel($(this));
    });

    window.addEventListener("resize", function () {
        $carousels.each(function () {
            syncCarousel($(this));
        });
    });
};

export default initPromotionalBannerSplitLayout;
